/**
 * The product's one typeface.
 *
 * Screens previously declared their own font on their root class and the
 * investor app ended up split between Inter and Poppins — the Offer Room and
 * Withdrawal in Inter, the Investment Portfolio and Transaction History in
 * Poppins. At identical size and weight the two look meaningfully different
 * (Poppins is geometric with a taller x-height and wider letterforms), so the
 * same `1.5rem/700` page title read as two different sizes depending on which
 * page you were on. Inter is the standard.
 *
 * The stack matters as much as the first entry: `fontFamily: "Inter"` with no
 * fallback drops to the browser's default serif if the webfont fails, which is
 * a far bigger visual break than any of the substitutes below.
 */
export const FONT_FAMILY =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif';

export default FONT_FAMILY;
